/**
 * A readable name for a language code.
 *
 * `Intl.DisplayNames` is part of the browser, so this covers every language the
 * desk has rows for without shipping a table or hardcoding a pair. The server's
 * own list is preferred when the caller has it, because an organisation may
 * name a language differently from the CLDR default.
 */
export function languageName(code, names) {
  if (!code) return '';
  if (names && names[code]) return names[code];
  try {
    return new Intl.DisplayNames(undefined, { type: 'language' }).of(code) ?? code.toUpperCase();
  } catch {
    return code.toUpperCase();
  }
}
